/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { LocalDataSource } from './LocalDataSource';
import { LiteralFilterExpression } from './LiteralFilterExpression';
import { PropertyReferenceFilterExpression } from './PropertyReferenceFilterExpression';
import { OperationFilterExpression } from './OperationFilterExpression';
import { FunctionFilterExpression } from './FunctionFilterExpression';
import { TypeRegistrar } from "./type";
var IgrLocalDataSourceModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrLocalDataSourceModule() {
    }
    IgrLocalDataSourceModule.register = function () {
        TypeRegistrar.register('LocalDataSource', LocalDataSource.$type);
        TypeRegistrar.register('LocalDataSource', LocalDataSource.$type);
        TypeRegistrar.register('LiteralFilterExpression', LiteralFilterExpression.$type);
        TypeRegistrar.register('LiteralFilterExpression', LiteralFilterExpression.$type);
        TypeRegistrar.register('PropertyReferenceFilterExpression', PropertyReferenceFilterExpression.$type);
        TypeRegistrar.register('PropertyReferenceFilterExpression', PropertyReferenceFilterExpression.$type);
        TypeRegistrar.register('OperationFilterExpression', OperationFilterExpression.$type);
        TypeRegistrar.register('OperationFilterExpression', OperationFilterExpression.$type);
        TypeRegistrar.register('FunctionFilterExpression', FunctionFilterExpression.$type);
        TypeRegistrar.register('FunctionFilterExpression', FunctionFilterExpression.$type);
    };
    return IgrLocalDataSourceModule;
}());
export { IgrLocalDataSourceModule };
//# sourceMappingURL=igr-local-data-source-module.js.map
